define((require) => {
    "use strict";

    const _ = require("underscore");

    // Regular expression to match the first line in a text...
    const FIRST_LINE_REGEX = /[.,;]|\n|<br>|<p>/igm;
    const TRIM_FIRST = /^\s+/;
    const TRIM_LAST  = /\s+$/;

    /**
     * Contains text utility functions.
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     *
     * @class TextUtil
     */
    const scope = {

        /**
         * Returns the "first logical line" of text from the supplied text. <p>
         *
         * The first line is determined as, in order:
         * - The first line ending with a dot (.), comma (,), or semi-colon (;).
         * - The text until the first new line or html break ("br" or "p" tag).
         *
         * In either case, the first line will be trimmed and have new lines and "br"/"p" removed (if matched on dot
         * or semi-colon), and will be truncated to the supplied maximum of characters. If truncated, ... will be
         * appended to the text. The first line matcher, e.g. a dot, will not be included in the first line.
         *
         * @param   {String}         text    The text to extract the first line from; if falsey, the empty string is
         *                                   returned.
         * @param   {Number|Boolean} [max]   The maximum numbers of allowed characters, defaulting to 32. Can also be
         *                                   <tt>quote</tt>.
         * @param   {Boolean}        [quote] True to quote the first line of text if non empty, false otherwise
         *                                   (default). Can also be supplied as the second argument.
         *
         * @returns {String} The first line of text; never null/undefined, but can be the empty string.
         */
        firstLine(text, max, quote) {
            // Removed prefixed spaces...
            text = (text || "").replace(TRIM_FIRST, "");
            if (text) {
                if (_.isBoolean(max)) {
                    quote = max;
                    max = 32;
                } else {
                    max  = max || 32;
                }
                if (FIRST_LINE_REGEX.test(text)) {
                    text = text.substring(0, FIRST_LINE_REGEX.lastIndex - 1);
                }
                // Trim tailing spaces before we test the max length...
                text = text.replace(TRIM_LAST, "");
                if (text.length > max) {
                    // Truncate, trim last (again), and add ...
                    text = `${text.substring(0, max).replace(TRIM_LAST, "")} &#x85;`;
                }
                // Could be trimmed entirely, and we do not want to quote the empty string...
                if (quote && text) {
                    text = `"${text}"`;
                }
            }
            return text;
        },

        /**
         * Lists the elements in the specified array, where each element is separated by the supplied
         * separator, with the last separator optionally different.
         *
         * @param {Array|*}  array          The array list generate a list form of; if non an array, will be returned
         *                                  as is. The array is not modified by this call.
         * @param {String}  [separator]     The separator used; will default to ", ".
         * @param {String}  [lastSeparator] The separator used; will default to (the defaulted) <tt>separator</tt>.
         *
         * @return {String|*} A list form the the supplied array; will be <tt>array</tt> as-is if not an array.
         */
        list(array, separator, lastSeparator) {
            let text = array;
            let last;

            if (_.isArray(array)) {
                if (!separator) { separator = ", "; }
                if (!lastSeparator) { lastSeparator = separator; }

                if (separator !== lastSeparator) {
                    last = array.pop();
                    text = array.join(separator) + lastSeparator + last;
                    array.push(last); // do not mess up incoming array!
                } else {
                    text = array.join(separator);
                }
            }
            return text;
        }
    };

    return scope;
});



// WEBPACK FOOTER //
// ./src/shared/util/TextUtil.js